// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Kysy Amigolta',
    assistant: 'Avustaja',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Kysy Amigolta, uusia: {{count}}',
    amigo_other: 'Kysy Amigolta, uusia: {{count}}',
    assistant_one: 'Avustaja, uusia: {{count}}',
    assistant_other: 'Avustaja, uusia: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo ei ole käytettävissä',
    assistant: 'Avustaja ei ole käytettävissä',
  },
  unavailable_text: {
    amigo: 'Amigo ei ole juuri nyt käytettävissä.',
    assistant: 'Avustaja ei ole juuri nyt käytettävissä.',
  },
};
